/* src/app/shared/widgets/slider/slider.component.scss */
.container {
  width: 100%;
  height: 100%;
  max-width: 100% !important;
}
img {
  object-fit: cover;
}
.pointer {
  cursor: pointer;
}
/*# sourceMappingURL=slider.component-RA3FGQPZ.css.map */
